const ConfirmScreen = ({
  amount,
  accountNumber,
  accountName,
  bankName,
  onConfirm,
  loading,
}) => (
  <div className="bg-white shadow-md p-6 rounded-2xl border">
    <h2 className="text-xl font-semibold text-[#003399] mb-4">
      Confirm Transfer
    </h2>

    <div className="space-y-3 text-sm">
      <div className="flex justify-between">
        <span className="text-gray-500">Account Name:</span>
        <span className="font-semibold">{accountName}</span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-500">Account Number:</span>
        <span className="font-semibold">{accountNumber}</span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-500">Bank:</span>
        <span className="font-semibold">{bankName}</span>
      </div>

      <div className="flex justify-between">
        <span className="text-gray-500">Amount:</span>
        <span className="font-semibold text-[#ED6E0A]">₦{amount}</span>
      </div>
    </div>

    <button
      onClick={onConfirm}
      className="w-full mt-6 bg-[#ED6E0A] text-white py-3 rounded-lg hover:opacity-90 disabled:opacity-50"
    >
      {loading ? "Processing..." : "Confirm Transfer"}
    </button>
  </div>
);

export default ConfirmScreen;